import styled, {css} from "styled-components"
import Flex from "@irati/ui/src/Flex"

export const CalendarHeader = styled.div`
  text-transform: uppercase;
  ${({theme}) => css`
    background-color: ${theme.colors.tertiary.r_400};
    color: ${theme.colors.greys.white};
    border-top-left-radius: ${theme.border.radius.large};
    border-top-right-radius: ${theme.border.radius.large};
    padding: ${theme.spacing.one} ${theme.spacing.two};
    font-size: ${theme.spacing.oneAndHalf};
  `}
`

export const CalendarBody = styled.div`
  text-align: center;
  ${({theme}) => css`
    font-size: ${theme.spacing.four};
    font-weight: ${theme.font.semibold};
  `}
`

export const CalendarWrapper = styled(Flex)`
  justify-content: center;
  ${({theme}) => css`
    background-color: ${theme.colors.greys.white};
    padding: ${theme.spacing.two};
    border-radius: ${theme.border.radius.large};
  `}
`
